import React, { useState } from 'react';
import './ContactForm.css';
import logo from './logo.svg';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    company: '',
    message: '',
    consent1: false,
    consent2: false
  });

  const [teamMembers, setTeamMembers] = useState([
    { id: 1, name: '', email: '' }
  ]);
  const [sending, setSending] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleTeamMemberChange = (id, field, value) => {
    setTeamMembers(prev =>
      prev.map(member =>
        member.id === id ? { ...member, [field]: value } : member
      )
    );
  };

  const addTeamMember = () => {
    const newId = teamMembers.length > 0 ? Math.max(...teamMembers.map(m => m.id)) + 1 : 1;
    setTeamMembers(prev => [...prev, { id: newId, name: '', email: '' }]);
  };

  const removeTeamMember = (id) => {
    if (teamMembers.length > 1) {
      setTeamMembers(prev => prev.filter(member => member.id !== id));
    }
  };

  const openPrivacyModal = (e) => {
    e.preventDefault();
    setShowPrivacyModal(true);
  };

  const closePrivacyModal = () => {
    setShowPrivacyModal(false);
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate required fields
    if (!formData.email || !formData.company || !formData.consent1 || !formData.consent2) {
      alert('Proszę wypełnić wszystkie wymagane pola i zaznaczyć zgody.');
      return;
    }
    if (teamMembers.some(m => !m.name || !m.email)) {
      alert('Proszę wypełnić dane wszystkich członków zespołu.');
      return;
    }
    setSending(true);
    try {
      const res = await fetch('https://mail.taxos.app/send-form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fromEmail: formData.email,
          teamMembers,
          message: formData.message,
          consent1: formData.consent1,
          consent2: formData.consent2
        })
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      if (data.success) {
        setShowSuccessModal(true);
        // Reset form after successful submission
        setFormData({
          email: '',
          company: '',
          message: '',
          consent1: false,
          consent2: false
        });
        setTeamMembers([{ id: 1, name: '', email: '' }]);
      } else {
        alert('Błąd wysyłania: ' + (data.error || 'Nieznany błąd'));
      }
    } catch (err) {
      console.error('Fetch error:', err);
      alert('Błąd połączenia z serwerem: ' + err.message);
    }
    setSending(false);
  };

  return (
    <div className="form-wrapper">
      <div className="logo-container">
        <img src={logo} alt="TaxOS Logo" className="logo" />
      </div>
      <div className="contact-form-container">
        <p>
          W formularzu poniżej wpisz dane członków swojego zespołu, aby zapewnić im dostęp do aplikacji TaxOS
          i wspólnie korzystać z jej funkcji. Po wypełnieniu formularza nasz zespół skontaktuje się ze zgłoszonymi
          osobami w celu aktywacji dostępu.
        </p>
        <form onSubmit={handleSubmit} className="contact-form">
          <hr className="contact-form-divider" />
          <div className="section-header">
            <h3>Twoje Dane</h3>
            <hr className="contact-form-divider" />
          </div>
          <div className="form-row">
            <div></div>
            <div className="form-group">
              <input
                type="text"
                id="company"
                name="company"
                placeholder="Twoja Firma"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Twój adres e-mail"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          <div className="section-header">
            <h3>Dane członków zespołu</h3>
            <hr className="contact-form-divider" />
          </div>
          {teamMembers.map((member, idx) => (
            <div className="form-row" key={member.id}>
              <div></div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Imię i Nazwisko"
                  value={member.name}
                  onChange={e => handleTeamMemberChange(member.id, 'name', e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Adres e-mail"
                  value={member.email}
                  onChange={e => handleTeamMemberChange(member.id, 'email', e.target.value)}
                  required
                />
              </div>
              <div>
                {teamMembers.length > 1 && idx > 0 && (
                  <button type="button" className="remove-person-button" onClick={() => removeTeamMember(member.id)}>
                    Usuń
                  </button>
                )}
              </div>
            </div>
          ))}
          <div className="add-person-container">
            <button type="button" className="add-person-button" onClick={addTeamMember}>
              +dodaj osobę
            </button>
          </div>
          <hr className="contact-form-divider" />
          <div className="form-group">
            <label htmlFor="message">Wiadomość:</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Dodatkowa wiadomość (opcjonalnie)"
            />
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="consent1"
              name="consent1"
              checked={formData.consent1}
              onChange={handleInputChange}
              required
            />
            <label htmlFor="consent1">
              W przypadku zamieszczania danych osobowych członków zespołu przez osobę trzecią, osoba wprowadzająca
              dane potwierdza, że otrzymała zgody na przetwarzanie danych osobowych tych osób przez EY na potrzeby
              dostępu do aplikacji Tax OS oraz osoba wprowadzająca dane zobowiązuje się w imieniu EY przekazać tym
              osobom powyższy link do Polityki Prywatności EY.
            </label>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              id="consent2"
              name="consent2"
              checked={formData.consent2}
              onChange={handleInputChange}
              required
            />
            <label htmlFor="consent2">
              Potwierdzam zapoznanie się z warunkami <a href="#" onClick={openPrivacyModal} className="privacy-link">Polityki Prywatności EY</a>.
            </label>
          </div>
          <button type="submit" className="submit-button" disabled={sending}>
            {sending ? 'Wysyłanie...' : 'Wyślij'}
          </button>
        </form>
      </div>
      
      {showPrivacyModal && (
        <div className="modal-overlay">
          <div className="modal-container privacy-modal">
            <div className="modal-header">
              <h2 className="modal-title">Informacja o polityce prywatności – TaxOS</h2>
              <button className="modal-close" onClick={closePrivacyModal}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
              </button>
            </div>
            <div className="modal-content privacy-content">
              <h2>Wprowadzenie</h2>
              <p>Niniejsza informacja o polityce prywatności ma na celu opisanie praktyk stosowanych przez EY w odniesieniu do TaxOS ("Narzędzie") w zakresie ochrony prywatności wszystkich osób, których dane osobowe są przetwarzane i przechowywane w Narzędziu.</p>
              
              <h2>Kto zarządza narzędziem?</h2>
              <p>"EY" odnosi się do jednej lub wielu firm członkowskich Ernst & Young Global Limited ("EYG"), z których każda jest odrębnym podmiotem prawnym i może działać samodzielnie jako administrator danych. Podmiotem pełniącym rolę administratora danych poprzez udostępnienie tego Narzędzia, na którym będą przetwarzane i przechowywane Twoje dane osobowe, jest EY Doradztwo Podatkowe Krupa sp. k.</p>
              <p>Dane osobowe w Narzędziu są udostępniane przez EY jednej lub kilku firmom członkowskim EYG (zobacz sekcję poniżej "Kto może mieć dostęp do twoich danych osobowych?").</p>
              <p>Narzędzie jest przechowywane na serwerach w EY Warsaw Data Center.</p>
              
              <h2>Dlaczego potrzebujemy Twoich danych osobowych?</h2>
              <p>Narzędzie jest platformą umożliwiającą wyszukiwanie zanonimizowanych dokumentów z dysków wspólnych EY.</p>
              <p>Twoje dane osobowe przetwarzane w Narzędziu są wykorzystywane w następujący sposób: TaxOS wykorzystuje Twoje dane osobowe takie jak imię, nazwisko, adres e-mail z dwóch powodów:</p>
              <ul>
                <li>Uwierzytelnienie (za pomocą EY SSO)</li>
                <li>Przechowywane informacji dla prawidłowego działania funkcjonalności narzędzia</li>
              </ul>
              <p>EY opiera się na następujących podstawach, aby uzasadnić przetwarzanie Twoich danych osobowych w Narzędziu: Przetwarzanie Państwa danych osobowych jest niezbędne dla celów realizacji uzasadnionych interesów przez administratora danych lub przez stronę trzecią, z wyjątkiem przypadków, gdy interesy te są nadrzędne w stosunku do interesów lub podstawowych praw i wolności podmiotu danych, które wymagają ochrony danych osobowych. Konkretne prawnie uzasadnione interesy są następujące: tworzenie i zapisywanie zapytań w Narzędziu. Przekazanie Twoich danych osobowych do EY jest opcjonalne. Jeśli jednak nie podasz wszystkich lub części swoich danych osobowych, możemy nie być w stanie zrealizować celów przetwarzania.</p>
              
              <h2>Jakiego rodzaju dane osobowe są przetwarzane w narzędziu?</h2>
              <p>Narzędzie przetwarza następujące kategorie danych osobowych: imię, nazwisko i adres e-mail.</p>
              <p>Narzędzie posiada puste pole, które umożliwia użytkownikom wprowadzanie tekstu. Jest to pole wyszukiwarki dokumentów.</p>
              
              <h2>Wrażliwe dane osobowe</h2>
              <p>Wrażliwe dane osobowe ujawniają Twoje pochodzenie rasowe lub etniczne, poglądy polityczne, przekonania religijne lub filozoficzne, przynależność do związków zawodowych, dane genetyczne, dane biometryczne, dane dotyczące zdrowia lub dane dotyczące życia seksualnego lub orientacji seksualnej.</p>
              <p>EY nie zbiera celowo żadnych wrażliwych danych osobowych za pomocą Narzędzia. Intencją Narzędzia nie jest przetwarzanie takich informacji. W związku z tym prosimy o nie wprowadzanie żadnych wrażliwych danych osobowych do Narzędzia.</p>
              
              <h2>Kto może mieć dostęp do twoich danych osobowych?</h2>
              <p>Twoje dane osobowe są dostępne w Narzędziu przez następujące osoby/zespoły:</p>
              <p>Dostęp będą mieli użytkownicy z następujących kategorii. Uwaga: nikt spoza EY oraz zewnętrznych konsultantów zatrudnionych przez EY (będącymi częścią zespołu dostarczającego Narzędzie) nie będzie miał dostępu do Narzędzia.</p>
              <ol>
                <li>Zespół EY dostarczający Narzędzie
                  <ul>
                    <li>Cel, dla którego wymagany jest dostęp: rozwój i konserwacja Narzędzia.</li>
                    <li>Poziom praw dostępu: odczyt, edycja i zapis.</li>
                  </ul>
                </li>
                <li>Administratorzy systemu EY i infrastruktury hostingowej
                  <ul>
                    <li>Cel, dla którego wymagany jest dostęp: Zadania administracyjne, konserwacja i wdrażanie.</li>
                    <li>Poziom praw dostępu: odczyt, edycja i zapis.</li>
                  </ul>
                </li>
              </ol>
              <p>Prawa dostępu wyszczególnione powyżej obejmują przekazywanie danych osobowych w różnych jurysdykcjach (w tym jurysdykcjach poza Unią Europejską), w których EY prowadzi działalność (siedziby biur EY są wymienione na stronie www.ey.com/ourlocations). EY będzie przetwarzać Twoje dane osobowe w Narzędziu zgodnie z obowiązującym prawem i regulacjami zawodowymi w Twojej jurysdykcji. Przekazywanie danych osobowych w ramach sieci EY podlega wiążącym regułom korporacyjnym EY (<a target="_blank" rel="noreferrer" href="http://www.ey.com/bcr">www.ey.com/bcr</a>).</p>
              
              <h2>Przechowywanie danych</h2>
              <p>Polityki i/lub procedury dotyczące zatrzymywania danych osobowych w Narzędziu są następujące:<br />Przechowywanie/usuwanie danych zgodnie z globalną polityką EY (EY Records Retention Global Policy).<br />Dane są przechowywane przez okres 7 lat.</p>
              <p>Twoje dane osobowe będą przechowywane zgodnie z przepisami i regulacjami dotyczącymi prywatności. Po upływie okresu przechowywania danych Twoje dane osobowe zostaną usunięte.</p>
              
              <h2>Bezpieczeństwo</h2>
              <p>EY dokłada wszelkich starań, aby Twoje dane osobowe były bezpieczne. Aby zapobiec nieautoryzowanemu dostępowi lub ujawnieniu, EY stosuje środki techniczne i organizacyjne w celu zabezpieczenia Twoich danych osobowych. Cały personel EY i strony trzecie zatrudnione przez EY do przetwarzania danych osobowych, są zobowiązani do przestrzegania poufności danych</p>
              
              <h2>Kontrolowanie Twoich danych osobowych</h2>
              <p>EY nie przekaże Państwa danych osobowych osobom trzecim (innym niż strony zewnętrzne, o których mowa w punkcie powyżej „Kto może mieć dostęp do twoich danych osobowych?"), chyba że uzyskamy Państwa zgodę lub jest to wymagane przez prawo.</p>
              <p>Zgodnie z prawem masz prawo zażądać od EY podania szczegółów danych osobowych dotyczących Ciebie.<br />Aby potwierdzić, czy Twoje dane osobowe są przetwarzane w Narzędziu lub uzyskać dostęp do Twoich danych osobowych w Narzędziu, skontaktuj się ze swoim przedstawicielem EY lub wyślij swoją prośbę na adres <a href="mailto:kontaktdaneosoboweEYPolska@pl.ey.com">kontaktdaneosoboweEYPolska@pl.ey.com</a></p>
              
              <h2>Poprawianie, usuwanie, ograniczanie przetwarzania lub przenoszenie danych</h2>
              <p>Możesz potwierdzić, że Twoje dane osobowe są dokładne i aktualne. Możesz poprosić o poprawienie, usunięcie, ograniczenie przetwarzania lub łatwą do przeniesienia kopię swoich danych osobowych, kontaktując się ze swoim przedstawicielem EY lub wysyłając e-mail na adres <a href="mailto:kontaktdaneosoboweEYPolska@pl.ey.com">kontaktdaneosoboweEYPolska@pl.ey.com</a></p>
              
              <h2>Skargi</h2>
              <p>Jeśli masz obawy związane z domniemanym naruszeniem prawa ochrony prywatności lub innych przepisów, skontaktuj się za pośrednictwem poczty elektronicznej pod adresem <a href="mailto:kontaktdaneosoboweEYPolska@pl.ey.com">kontaktdaneosoboweEYPolska@pl.ey.com</a> lub za pośrednictwem swojego przedstawiciela EY. Lider ds. prywatności w EY przeprowadzi dochodzenie w sprawie Twojej skargi i przedstawi informacje na temat sposobu jej rozpatrzenia i rozwiązania.</p>
              <p>Jeśli nie jesteś zadowolony ze sposobu, w jaki EY rozwiązał Twoją skargę, masz prawo do złożenia skargi do organu ochrony danych osobowych w swoim kraju. Możesz również skierować sprawę do właściwego sądu.</p>
              
              <h2>Skontaktuj się z nami</h2>
              <p>Jeśli masz dodatkowe pytania lub wątpliwości, skontaktuj się ze swoim przedstawicielem EY lub wyślij e-mail na adres <a href="mailto:kontaktdaneosoboweEYPolska@pl.ey.com">kontaktdaneosoboweEYPolska@pl.ey.com</a></p>
            </div>
            <div className="modal-footer">
              <button className="privacy-notice-button" onClick={closePrivacyModal}>
                <span>Akceptuję</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="modal-overlay" onClick={closeSuccessModal}>
          <div className="modal-container privacy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Formularz wysłany pomyślnie!</h2>
            </div>
            <div className="modal-body">
             
              <p>Dziękujemy za przesłanie formularza. Skontaktujemy się z Tobą wkrótce.</p>
            </div>
            <div className="modal-footer">
              <button className="privacy-notice-button" onClick={closeSuccessModal}>
                <span>OK</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;